// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withApi } from '@tencent/react-aio';
import * as ActionTypes from '@/stores/sale/actions';
import _ from 'lodash';
import buildSiteMap from '@/common/menus/buildSiteMap';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import duration from 'dayjs/plugin/duration';
import weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/zh-cn';
import MessageBox, { MessageBoxContainer } from '@/components/MessageBox';
import commonReport from '@/common/common-report.js';
import CGI from '@/api/operator/cgi/smb/manage/role.js';
import { getUserId } from '@/api/operator/cgi/smb/common';
import cookie from '@/utils/cookie.js';
import { saveCombinedValue, getFromCombinedValue } from '@/utils/storage';
import { AccountContext } from '@/business-components/operator/account-context.js';
import { isOa } from '@/utils/index';
import DebugInfo from './debug-info.js';
import { getAccountList, getFeatureFlagList } from '@/api/operator/cgi/smb/common/index.js';
import { reportUserBehavior } from '@/pages/agency/utils/util';
import { ACCOUNT_TYPE, AD_PLATFORM_TYPE, AD_PLATFORM_TYPE_NAME, AGENCY_UID_COOKIE_NAME, AD_PLATFORM_TYPE_RULE, FLAGS } from '@/constants/Constants';
import { arrayToMap, isInIframe } from '@/utils';
import globalStore from '@/stores';
import modal from '@/utils/modal.js';
import Skeleton from '@/common-components/skeleton';
import Routes from './routes';
import '@/assets/less/cm.less';
import TopNavBar from '@/common-components/HeaderBar/TopNavBar.js';
import Watermark from '@/business-components/watermark';
import GuideManager from '@/common-components/guide-manager';
// import Help from '@/common-components/help';
import smartQ from '@/common/smartq';
import RealNameSideBar from '@/common-components/operation-guide-sidebar';
import menus from '@/common/menus';
import { initAssistant } from '@tencent/ams-assistant-ui-bridge';

// import Agreement from '@/common-components/HeaderBar/Agreement.js';
import Agreement from '@/common-components/new-agreement';
import CallCenterDock from '@/business-components/sale/callcenter/CallCenterDock';
import TargetBoard from '@/business-components/sale/TargetBoard';
import Footer from '@/app/Footer';
import { getEditWechatNumberDialogConfig, getPhoneEditDialogConfig } from '@/pages/agency/personal-center/services/edit-userinfo-warn';
import { getComplaintNoticeDialogConfig } from '@/pages/agency/account/complaint/warn';
import { WarnDialogManager } from '@/common-components/warn-dialog';
import { getRainbowCommonConfig } from '@/api/rainbow';

// import TaskNotification from '@/pages/agency/report/timedtask/component/TaskNotification';
import DailyReportNotification from '@/pages/agency/download/daily-report/notification';

import TaskCenterService from '@/pages/agency/task/TaskCenter/services';
import IPExceptionCheck from './IPExceptionCheck';
import AdminRealNameGuide from '@/common-components/admin-real-name-guide';
import { hasFeatureFlag } from '@/services';
import { checkSvip, getSvipAuditStatus } from '@/api/operator/cgi/agm';
import { SignFrameStatus, UserVerifyType } from '@/model/agency';
import { initPassiveAccSummary, initPassiveAccAuth } from '@/pages/agency/report/passive-accumulation/services';
import { initContractSummary } from '@/pages/agency/manage/contract/services';

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(quarterOfYear);
dayjs.extend(duration);
dayjs.extend(weekday);
dayjs.locale('zh-cn');

class AppContainer extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    loginStatus: PropTypes.object,
  }

  state = {
    account: {},
    isOaAuthing: false,
    warnDialogConfigs: [],
    globalConfig: {},
  }

  constructor(props) {
    super(props);
    this.messageBox = React.createRef();
    this.funcs = {
      strongwarn: this.strongwarn,
      warn: this.warn,
      loading: this.loading,
      success: this.success,
      error: this.error,
      info: this.info,
      confirm: this.confirm,
    };

    this.getAccountInfo = isOa() ? this.getOaAccountInfo : this.getEqqAccountInfo;
  }

  componentDidMount() {
    this.initHistory();
    this.initGlobalConfig();
    commonReport.init();

    window.addEventListener('storage', () => {
      // 事件支持多tab监听
      const newUserId = window.localStorage.getItem('user_id');
      if (newUserId && this.state.account.user_id && +this.state.account.user_id !== +newUserId) {
        if (window.tccc) {
          // 登录失效，关闭t3c的登录状态，避免可以接听电话
          window.tccc.Agent.offline();
        }
        modal.error('当前页面下有其他账号在不同设备、浏览器或选项卡发生了登录操作。请刷新以同步至最新登录账户，或切换其他账号登录', {
          title: '登录账户发生变更',
          submitLabel: '刷新页面',
          cancelButton: false,
          closeButton: false,
          onSubmit: () => window.location.reload(),
        });
      }
    });

    const startTimestamp = new Date().getTime();
    this.getAccountInfo()
      .then((data) => {
        commonReport.setLoginStatus({
          ...data,
          agency_uid: Number(cookie.get(AGENCY_UID_COOKIE_NAME.default) || 0),
        });

        // 初始化请求完成
        this.setState({ isCgiDone: true }, () => {
          const endTimestamp = new Date().getTime();
          commonReport.reportTime('initRequest', endTimestamp - startTimestamp);
        });

        // 页面初始化pv上报
        reportUserBehavior({ behaviorType: '打开页面' });

        // 初始化妙问客服
        smartQ.init();
        return data;
      })
      .then((data) => {
        // 公共信息
        if (!isOa()) {
          try {
            // 公共信息，影响导航路由
            this.getCommonInfo(data);
            // 初始化弹窗
            this.initWarnDialog();
            // 任务类型
            TaskCenterService.initTaskType();
            // 获取被动累量下载状态
            initPassiveAccSummary();
            // 获取待签署合同状态
            initContractSummary();
            // 页面提示
            this.getPageNotice();
          } catch (error) {
            console.error(error);
          }
        }
        // 获取销售额外信息（异步即可）
        if (data.hasSaleRole) {
          try {
            this.getSaleExtraInfo();
          } catch (error) {
            console.error(error);
          }
        }
      })
      .catch((error) => {
        // commonReport.reportError({ message: '帐号信息错误', error });
        this.setState({ isCgiDone: true, error });
      });

    try {
      initAssistant({ name: 'agency' });
    } catch (error) {
      console.error('Failed to initialize assistant:', error);
    }
  }

  initGlobalConfig = async () => {
    const config = await getRainbowCommonConfig('global_config');
    this.setState({ globalConfig: config || {} });
  }

  // 路由监听初始化
  initHistory = () => {
    const { history } = this.props;
    if (history) {
      globalStore.setHistory(history);
      history.listen((location, action) => {
        // 应业务要求回滚，整体pv偏大
        // if (action === 'PUSH') {
        // 列表筛选项地址栏参数保持这类不上报
        if (action !== 'REPLACE') {
          reportUserBehavior({ behaviorType: '打开页面' });
        }
      });
    }
  }

  // 展示公告
  getPageNotice = async () => {
    const config = await getRainbowCommonConfig('page_notice');
    globalStore.setPageNoticeConfig(config);
  }

  // 展示用户提醒dialog
  initWarnDialog = async () => {
    let warnDialogConfigs = await Promise.all([
      getComplaintNoticeDialogConfig(),
      getEditWechatNumberDialogConfig(),
      // getPhoneEditDialogConfig(),
    ]);
    let index = 0;
    warnDialogConfigs = warnDialogConfigs.filter((item) => !!item);
    warnDialogConfigs.forEach((item) => {
      item.index = index++;
    });
    this.setState({
      warnDialogConfigs,
    });
  }

  // 获取本地缓存登录信息
  getLocalLoginInfo = async () => {
    const res = await getUserId();
    const userId = res?.data?.user_id;
    const { enableLocalLoginCache } = this.state.globalConfig;
    if (userId && (enableLocalLoginCache === true || (Array.isArray(enableLocalLoginCache) && enableLocalLoginCache.includes(userId)))) {
      // 用户登录信息
      const userInfo = getFromCombinedValue(
        FLAGS.LOGIN_INFO_CACHE_KEY.GLOBAL_KEY,
        FLAGS.LOGIN_INFO_CACHE_KEY.ACCOUNT_INFO_KEY,
        {
          userId,
          useSessionStorage: true,
        },
      );
      if (userInfo) {
        try {
          return JSON.parse(userInfo);
        } catch (error) { }
      }
    }
    return Promise.reject(null);
  }

  // 获取远程登录信息
  getRemoteLoginInfo = async () => {
    const res = await CGI.getAccountInfo();
    // 缓存用户信息
    if (res?.code === 0) {
      saveCombinedValue(
        FLAGS.LOGIN_INFO_CACHE_KEY.GLOBAL_KEY,
        FLAGS.LOGIN_INFO_CACHE_KEY.ACCOUNT_INFO_KEY,
        JSON.stringify(res),
        {
          userId: res?.data?.user_id,
          useSessionStorage: true,
        },
      );
    }
    return res;
  }

  /**
   * @description e.qq域名获取账户信息
   */
  getEqqAccountInfo = async () => {
    const { webApi } = this.props;

    // Step1: 获取账户信息
    const res = await Promise.any([
      this.getLocalLoginInfo(),
      this.getRemoteLoginInfo(),
    ]);

    const accountInfo = _.get(res, 'data', {});
    const {
      user_id,
      bm_id,
      agency_uid,
      sale_agency_uid,
      agency_list: _agency_list = [],
      privilege_list: _privilege_list = {},
      feature_flag_list = {},
      tech_agency_list = [],
    } = accountInfo;
    const env = _.get(res, 'env', '');
    const hasSaleRole = Boolean(sale_agency_uid);
    const feature_flag = feature_flag_list[bm_id || agency_uid] || {};

    window.localStorage.setItem('user_id', user_id);

    // 加上默认权限0
    const privilege_list = {
      0: {
        privilege_id: 0,
        privilege_name: '默认权限',
      },
      ..._privilege_list,
    };

    // 直销特殊处理
    let account_type = ACCOUNT_TYPE.default;
    const agency_list = _agency_list.map((v) => {
      account_type = v.account_type || ACCOUNT_TYPE.default;
      if (account_type === ACCOUNT_TYPE.direct) {
        return {
          ...v,
          ad_platform_type: v.direct_agency_type || AD_PLATFORM_TYPE.GDT,
          is_cps: 0,
          is_adx: 0,
        };
      }
      return v;
    });
    // 平台信息
    const hasPlatform = {
      [AD_PLATFORM_TYPE_NAME.ADQ]: Boolean(_.find(agency_list, AD_PLATFORM_TYPE_RULE[AD_PLATFORM_TYPE_NAME.ADQ])),
      [AD_PLATFORM_TYPE_NAME.MP]: Boolean(_.find(agency_list, AD_PLATFORM_TYPE_RULE[AD_PLATFORM_TYPE_NAME.MP])),
      [AD_PLATFORM_TYPE_NAME.CPS]: Boolean(_.find(agency_list, AD_PLATFORM_TYPE_RULE[AD_PLATFORM_TYPE_NAME.CPS])),
    };

    // 销售额外权限
    // 菜单中的资产用到了销售 status 接口中的权限判断，所以无论是否销售服务商都可以使用资产
    // 所以无论是否销售服务商，都拉 status 接口用于菜单权限处理，其他逻辑保持不变
    let saleStatus = {};
    let extraPermissions = [];
    try {
      saleStatus = await webApi.getLoginStatus().dispatch(ActionTypes.FETCH_LOGIN_STATUS) || {};
      extraPermissions = saleStatus.extraPermissions || [];
    } catch (error) {
      console.error(error);
    }

    const privilege = _.uniq([
      ...Object.keys(privilege_list)
        .map((v) => Number(v)),
      ...extraPermissions,
    ]);

    const allAgencyList = _.concat(agency_list || [], tech_agency_list || []);

    const _account = {
      ...this.state.account,
      ...accountInfo,
      saleStatus,
      hasSaleRole,
      env,
      privilege,
      privilege_list,
      feature_flag,
      account_type,
      hasPlatform,
      agency_list,
      agency_list_map: arrayToMap(allAgencyList, 'agency_uid'),
      featureFlagInitDone: false,
      onlyTechAgency: !agency_list.length && tech_agency_list.length > 0,
      hasTechAgency: tech_agency_list.length > 0,
      all_agency_list: allAgencyList,
      dynamicNavAuth: null,
      /**
         * @description 任意有一个权限满足即可
         * @param perm {number | array}
         * @returns {boolean}
         */
      oneOf: (perm) => {
        if (typeof perm === 'number') {
          return _.includes(privilege, perm);
        }
        return _.intersection(perm, privilege).length > 0;
      },
      /**
         * @description 所有的权限需都满足才可通过
         * @param perm {number | array}
         * @returns {boolean}
         */
      allOf: (perm) => {
        if (typeof perm === 'number') {
          return _.includes(privilege, perm);
        }
        return _.difference(perm, privilege).length === 0;
      },
    };

    const siteMap = buildSiteMap(_account);
    const account = {
      ..._account,
      siteMap,
    };

    this.setState({
      account,
    });
    globalStore.setAccount(account);

    cookie.set('bm_id', bm_id, null, '/', 72);
    const cookieAgencyUid = cookie.get(AGENCY_UID_COOKIE_NAME.default);
    // 预留：testhub预发布环境报错
    // if (!Number(cookieAgencyUid) || !_.has(account.agency_list_map || {}, cookieAgencyUid)) {
    if (!Number(cookieAgencyUid)) {
      cookie.set(AGENCY_UID_COOKIE_NAME.default, agency_uid || allAgencyList?.[0]?.agency_uid || 0, null, '/', 72);
    } else {
      cookie.set(AGENCY_UID_COOKIE_NAME.default, cookieAgencyUid, null, '/', 72);
    }
    return account;
  }

  /**
   * @description OA域获取账户数据
   * @return Promise<Object>
   */
  getOaAccountInfo = () => {
    const { webApi } = this.props;
    return webApi
      .getLoginStatus()
      .dispatch(ActionTypes.FETCH_LOGIN_STATUS)
      .then((loginStatus) => {
        this.getSaleExtraInfo();
        const privilege = loginStatus?.userPermissions || [];
        let account = {
          hasSaleRole: true,
          isOa: isOa(),
          saleStatus: loginStatus,
          feature_flag_list: {},
          feature_flag: {},
          privilege_list: {},
          privilege,
          role_list: {},
          /**
           * @description 任意有一个权限满足即可
           * @param perm {number | array}
           * @returns {boolean}
           */
          oneOf: (perm) => {
            if (typeof perm === 'number') {
              return _.includes(privilege, perm);
            }
            return _.intersection(perm, privilege).length > 0;
          },
          /**
           * @description 所有的权限需都满足才可通过
           * @param perm {number | array}
           * @returns {boolean}
           */
          allOf: (perm) => {
            if (typeof perm === 'number') {
              return _.includes(privilege, perm);
            }
            return _.difference(perm, privilege).length === 0;
          },
        };

        const siteMap = buildSiteMap(account);

        account = { ...account, siteMap };

        this.setState({ account });
        globalStore.setAccount(account);

        return account;
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.href = 'http://mingan.oa.com/login/login_oa_v2.php?sys_id=2550&login_mode=oa&sys_url=http://agent.tsa.oa.com/ags/ags/auth/redirectOA';
          this.setState({ isOaAuthing: true });
          return Promise.resolve();
        }
        return Promise.reject(error);
      });
  }

  /**
   * @description e.qq公共信息
   */
  getCommonInfo = async (data = {}) => {
    const { feature_flag_list = [], feature_flag = {}, bm_id, agency_uid } = data;
    let resList = [];
    try {
      // Step3: 获取白名单、账户列表、ISV信息等信息
      resList = await Promise.allSettled([
        // 获取账户列表
        getAccountList(),
        // 获取ISV信息
        this.getExtraMenuMap(),
        // 获取动态导航权限
        this.getDynamicNavAuth(),
        // 获取灰度开关列表
        getFeatureFlagList(),
        // 获取用户认证信息
        this.getUserVerifyInfo(),
      ]);
    } catch (error) {
      console.error(error);
    }

    // 账户列表
    const accountList = _.get(resList, '0.value.data', {});
    const agency_login_list = [
      ...(accountList.bm_list || []).map((x) => {
        return {
          label: x.bm_name,
          id: `主体ID:${x.bm_id}`,
          value: x.bm_id,
          isBm: true,
        };
      }),
      ...(accountList.agency_list || []).map((x) => {
        return {
          label: x.agency_name,
          id: `账户ID:${x.agency_uid}`,
          value: x.agency_uid,
          isBm: false,
        };
      }),
    ];

    // ISV信息
    const extraMenuMap = _.get(resList, '1.value', {});

    // 获取动态导航权限
    const dynamicNavAuth = _.get(resList, '2.value', {});

    // 灰度开关列表
    const FeatureFlagList = _.get(resList, '3.value.data.feature_flag_list', {});
    const allFeatureFlagList = _.merge({}, feature_flag_list, FeatureFlagList);

    // svip信息
    const userVerifyInfo = _.get(resList, '4.value', {});

    const _account = {
      ...data,
      feature_flag_list: allFeatureFlagList,
      feature_flag: {
        ...feature_flag,
        ...(allFeatureFlagList[bm_id || agency_uid] || {}),
      },
      agency_login_list,
      dynamicNavAuth,
      extraMenuMap,
      featureFlagInitDone: true,
      userVerifyInfo,
    };

    const siteMap = buildSiteMap(_account);
    const account = {
      ..._account,
      siteMap,
    };

    this.setState({
      account,
    });
    globalStore.setAccount(account);
    return account;
  }

  /**
   * @description 获取动态导航权限
   */
  getDynamicNavAuth = async () => {
    let resList = [];
    try {
      resList = await Promise.allSettled([
        // 获取任务scope
        TaskCenterService.initTaskScope(),
        // 获取被动累量权限
        initPassiveAccAuth(),
      ]);
    } catch (error) {
      console.error(error);
      return {};
    }

    // 任务scope信息
    const taskTeamEnable = _.get(resList, '0.value', false);

    // 被动累量权限
    const passiveAccEnable = _.get(resList, '1.value', false);

    return {
      taskTeamEnable,
      passiveAccEnable,
    };
  }

  /**
   * @description 获取销售额外信息
   */
  getSaleExtraInfo = async () => {
    const { webApi } = this.props;
    try {
      await Promise.all([
        webApi.getAreaList().dispatch(ActionTypes.FETCH_AREA_LIST),
        webApi.getIndustryList().dispatch(ActionTypes.FETCH_INDUSTRY_LIST),
        webApi.getPromotedObjectList().dispatch(ActionTypes.FETCH_PROMOTED_OBJECT_LIST),
        webApi.getSourceTypeList().dispatch(ActionTypes.FETCH_SOURCE_TYPE_LIST),
        webApi.getSourceTypeTag().dispatch(ActionTypes.FETCH_SOURCE_TYPE_TAG),
        ...(!isOa() ? [
          webApi.getCustomerProtectionWhiteList().dispatchJson(ActionTypes.FETCH_CUSTOMER_PROTECTION_WHITE_LIST),
        ] : []),
      ]);
    } catch (error) {
      console.error('获取销售额外信息出错', error);
    }
  }

  /**
   * @description 获取ISV信息
   */
  getExtraMenuMap = async () => {
    try {
      const { code, data } = await CGI.getIsvAgencyClients();
      if (code === 0) {
        const { list: mktList = [] } = data;
        const mktData = [...mktList.map((v) => ({
          ...v,
          id: 'mkt',
          key: `mkt-${v.client_id}`,
          label: v.client_name,
          desc: v.description,
          href: `https://isv.e.qq.com?from=amshomesgj&client_id=${v.client_id}`,
          target: '_blank',
          isNew: dayjs().add(-7, 'day')
            .isBefore(dayjs(v.attach_time)),
        })), {
          id: 'mkt_add',
          label: '添加更多应用',
          desc: '聚合优质三方生态服务和工具，提供广告全链路工具方案',
          href: 'https://isv.e.qq.com?from=amshomesgj',
          key: 'manage-mkt-add',
          target: '_blank',
          useNavOpenReport: true,
          navOpenReportParams: {
            page2: '营销服务市场',
          },
        }];
        const extraMenuMap = {
          mkt: {
            data: mktData,
          },
        };
        return extraMenuMap;
      }
    } catch (error) { }
    return {};
  }

  /**
   * @description 获取用户认证信息
   */
  getUserVerifyInfo = async () => {
    if (!hasFeatureFlag('is_enable_svip_strict_employee_rule') && !hasFeatureFlag('is_enable_nonframe_strict_employee_rule')) {
      return {
        agentGroup: '',
        isSvip: false,
        isNonFrame: false,
      };
    }
    try {
      const checkRes = await checkSvip();
      if (checkRes.code === 0) {
        const { is_svip_provider, agent_group, sign_frame_status } = checkRes.data || {};
        const isSvip = hasFeatureFlag('is_enable_svip_strict_employee_rule') && is_svip_provider;
        const isNonFrame = hasFeatureFlag('is_enable_nonframe_strict_employee_rule') && sign_frame_status === SignFrameStatus.nonFrame;
        // 用户类型
        let userType = UserVerifyType.frame;
        if (isSvip) {
          userType = UserVerifyType.svip;
        } else if (isNonFrame) {
          userType = UserVerifyType.nonFrame;
        }
        const auditRes = await getSvipAuditStatus({
          user_type: userType,
        });
        if (auditRes.code === 0) {
          return {
            agentGroup: agent_group,
            isSvip,
            isNonFrame,
            sign_frame_status,
            ...auditRes.data || {},
          };
        }
      }
    } catch (error) {
      console.error('获取svip信息出错', error);
    }
    return {
      agentGroup: '',
      isSvip: false,
      isNonFrame: false,
    };
  }

  render() {
    const { account, isCgiDone, isOaAuthing, warnDialogConfigs } = this.state;

    const { children } = this.props;

    let content = children ? children : <AppContent account={account} warnDialogConfigs={warnDialogConfigs} />;

    if (!isCgiDone) {
      content = <Skeleton showTopNav={!isInIframe()} />;
    }

    if (isOaAuthing) {
      content = (
        <div style={{ padding: '20px' }}>
          <h1>loading...</h1>
          <p>OA权限验证中，请稍等</p>
        </div>
      );
    }

    if (this.state.error) {
      content = null;
    }

    return (
      <AccountContext.Provider value={account}>
        <MessageBox.Provider value={this.funcs}>{content}</MessageBox.Provider>
        <MessageBoxContainer ref={this.messageBox} />
        <DebugInfo></DebugInfo>
      </AccountContext.Provider>
    );
  }

  strongwarn = (title, message) => {
    this.messageBox.current.strongwarn(title, message);
  }

  warn = (title, message) => {
    this.messageBox.current.warn(title, message);
  }

  loading = (title, message) => {
    this.messageBox.current.loading(title, message);
  }

  success = (title, message) => {
    this.messageBox.current.success(title, message);
  }

  error = (title, message) => {
    this.messageBox.current.error(title, message);
    // commonReport.reportError({ title, message });
  }

  info = (title, message) => {
    this.messageBox.current.info(title, message);
  }

  confirm = (title, message, onSubmit, onCancel) => {
    this.messageBox.current.confirm(title, message, onSubmit, onCancel);
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.loginStatus,
  };
}

const guidList = menus
  .filter((item) => item.desc)
  .map((item) => {
    return {
      label: item.label,
      desc: item.desc,
      key: item.key,
    };
  });

// APP内容
function AppContent({ account, warnDialogConfigs }) {
  return (
    <React.Fragment>
      <CallCenterDock />
      <TargetBoard />
      {/* <Help account={account} /> */}
      <RealNameSideBar />
      <AdminRealNameGuide />
      <TopNavBar account={account}></TopNavBar>
      <div className="aegis-first-screen-timing" aegis-first-screen-timing></div>
      {isOa() ? null : <WarnDialogManager warnDialogConfigs={warnDialogConfigs} account={account} />}
      <GuideManager flag={FLAGS.GUIDE} guidList={guidList}></GuideManager>
      <Agreement />
      {account?.hasSaleRole && !isOa() ? <Footer /> : null}
      <Routes account={account} />
      {account ? <Watermark /> : null}
      {!isOa() ? <DailyReportNotification /> : null}
      {!isOa() ? <IPExceptionCheck /> : null}
    </React.Fragment>
  );
}

AppContent.propTypes = {
  account: PropTypes.object.isRequired,
  warnDialogConfigs: PropTypes.array.isRequired,
};

export default withApi(connect(mapStateToProps)(AppContainer));
